'use client';

import {useCallback, useContext, useSyncExternalStore} from 'react';
import {ActiveScreenIdSubscriptionContext} from './ActiveScreenIdProvider';

/**
 * Returns true when more than one screen is selected. Re-renders only when
 * the boolean flips — not on every selection mutation — unlike
 * useSelectedScreenIds().length > 1 which re-renders on every array change.
 */
export function useMultipleNodesSelected(): boolean {
  const {subscribe, getSnapshot} = useContext(
    ActiveScreenIdSubscriptionContext,
  );
  const getIsMultiple = useCallback(
    () => getSnapshot().length > 1,
    [getSnapshot],
  );
  return useSyncExternalStore(subscribe, getIsMultiple, getIsMultiple);
}
